import Vue from "vue";
import App from "./App.vue";
import lodash from "lodash";
// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
import VCalendar from "v-calendar";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import vueDebounce from "vue-debounce";

Vue.use(vueDebounce, {
  listenTo: "input"
});

Vue.use(Vuesax);
Vue.use(VCalendar);
Vue.use(BootstrapVue);

import vClickOutside from "v-click-outside";

Vue.use(vClickOutside);

// Optionally install the BootstrapVue icon components plugin

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

//vue-lodash
import VueLodash from "vue-lodash";
Vue.use(VueLodash, { name: "custom", lodash: lodash });

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
